import React from 'react';
import { useAccount } from '@src/contexts/auth-context';
import { Path } from '@src/navigations/routes';
import { Navigate, Outlet } from 'react-router-dom';
import Box from '@sendsprint/ui-react/dist/components/Box';
import { ReactComponent as Logo } from '@sendsprint/design-system/brand/logos/logo-full-green.svg';
import Container from '@src/components/container';
import Text from '@sendsprint/ui-react/dist/components/Text';

const AuthLayout = () => {
  const { isLoggedIn } = useAccount();

  if (isLoggedIn) {
    return <Navigate to={Path.Dashboard} replace />;
  }

  return (
    <Box>
      <Box className="ss-py-7 ss-sticky ss-top-0">
        <Container>
          <Text variant="h6" className="ss-flex !ss-leading-none ss-gap-2">
            GlobalRemit
          </Text>
        </Container>
      </Box>
      <Box as="main" className="ss-pt-10 md:ss-pt-20 ss-pb-10">
        <Outlet />
      </Box>
    </Box>
  );
};

export default AuthLayout;
